import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETarget} from '../../../react-oe/oe-target';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEImplantcastTargetType = {
    anatomy:        'anatomy',
    op:             'op'
};

OEImplantcastTargetType.all = [
    OEImplantcastTargetType.anatomy,
    OEImplantcastTargetType.op
];

export const opTargets = [
    OETarget.humanKneeImplantcast,
    OETarget.implantcastACSMB4in1,
    OETarget.implantcastACSSCFB,
    OETarget.implantcastAGILONMI,
    OETarget.implantcastACSSCMB,
    OETarget.implantcastMutarsDistFemurMK,
    OETarget.implantcastMUTARSGenuXMK,
    OETarget.implantcastMUTARSKRIMK,
    OETarget.implantcastEcoFitHipStem133123,
    OETarget.implantcastEcoFitHipStem,
    OETarget.implantcastEcoFitShortStem,
    OETarget.implantcastEcoFitCup,
    OETarget.implantcastActiniaStem,
    OETarget.implantcastTestTarget,
// @ADD_TARGET_IMPLANTCAST_OPTLIST
    OETarget.implantcastHAPTic,
    OETarget.implantcastICARA,
    OETarget.implantcastCarpoFit,
    OETarget.implantcastIntramedullaryPlug,
    OETarget.implantcastHipDorsalApproach,
    OETarget.implantcastKneeMedialParapatellarApproach,
    OETarget.implantcastKneeLateralParapatellarApproach,
    OETarget.implantcastMutarsRScup,
    OETarget.implantcastEporeMetaphysealComponentsGenuX,
    OETarget.implantcastMutarsProxFemurDiaphyse,
    OETarget.implantcasticStraightStem,
    OETarget.implantcastMutarsProxFemurRevision,
    OETarget.implantcastDiaLocRS,
    OETarget.materialTestTarget,
    OETarget.implantcastMutarsTotalHumerus,
    OETarget.implantcastMutarsDistHumerus30mm,
    OETarget.implantcastACSUniFB,
    OETarget.implantcastEporeConeKRIundRSArthrodese,
    OETarget.implantcastEporeConesCortical,
    OETarget.implantcastMutarsDiaphysealImplant,
    OETarget.implantcastMutarsProxFemurRS,
    OETarget.implantcastACSMBAllinOne,
    OETarget.implantcastMutarsDistHumerus50mm,
    OETarget.implantcastMutarsTotalKneeKRIMK,
    OETarget.implantcastMutarsTotalKneeMK,
    OETarget.implantcastMutarsIntramedtotalFemurMK,
    OETarget.implantcastMutarsHumerusDiaphysealImplant,
    OETarget.implantcastACSUniSG,
    OETarget.implantcastEporeConesMetaphyseal,
    OETarget.implantcastMutarsTotalElbow,
    OETarget.implantcastACSFBAllinOne,
    OETarget.implantcastMutarsIntramedtotalFemurGenuX,
    OETarget.implantcastMutarsArthrodesisimplant,
    OETarget.implantcastMutarsProxUlnaLongFit,
    OETarget.implantcastMutarsTorqueWrench,
    OETarget.implantcastMutarsRSArthrodesisImplant,
    OETarget.implantcastDeltopectoralApproach,
    OETarget.implantcastMutarsTotalesFemurMK,
    OETarget.implantcastMutarsDistFemurRS,
    OETarget.implantcastMutarsHumerusInvers,
    OETarget.implantcastMUTARSModularStem,
    OETarget.implantcastEcoFitHipStem123,
    OETarget.implantcastPEcupMuellerII,
    OETarget.implantcastEcoFitSC,
    OETarget.implantcastEcoFit2MSP,
    OETarget.implantcastEcoFit2M,
    OETarget.implantcastMutarsProxFemur,
    OETarget.implantcastMUTARSProxTibiaMK,
    OETarget.implantcastMutarsProxHumerus,
    OETarget.implantcastMutarsLumic,
    OETarget.implantcastAgilonPEGlenoid,
    OETarget.implantcastAGILONGlenoidzementfrei,
    OETarget.implantcastAGILONTraumalongfit,
    OETarget.implantcastMutarsRS,
    OETarget.implantcastDirectAnteriorApproach,
    OETarget.implantcastEcoFitCupEPORE,
    OETarget.implantcastMUTARSPRS,
    OETarget.implantcastAGILONOmarthrosisLongFit,
];

export const OEImplantcastStartSelectionContent = {

    [OEImplantcastTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        {target: OETarget.humanArm, label: {text: 'Upper extremity', id: 'target_menu_humanArmMenuItem'}},
                        {target: OETarget.humanShoulderGirdle, label: {text: 'Shoulder girdle', id: 'target_menu_humanShoulderGirdle'}},
                        {target: OETarget.humanUpperArmElbow, label: {text: 'Upper arm / elbow', id: 'target_menu_humanUpperArmElbow'}},
                        {target: OETarget.humanForearm, label: {text: 'Forearm', id: 'target_menu_humanForearm'}},
                        {target: OETarget.humanHand, label: {text: 'Human Hand', id: 'target_menu_humanHand'}},
                    ]
                },
                {
                    items: [
                        {target: OETarget.humanLeg, label: {text: 'Lower extremity', id: 'target_menu_humanLegMenuItem'}},
                        {target: OETarget.humanHip2, label: {text: 'Hip', id: 'target_menu_humanHip2'}},
                        {target: OETarget.humanThighKnee, label: {text: 'Thigh and knee', id: 'target_menu_humanThighKnee'}},
                        {target: OETarget.humanLowerLeg, label: {text: 'Lower leg', id: 'target_menu_humanLowerLeg'}},
                        {target: OETarget.humanAnkleFoot, label: {text: 'Ankle / Foot', id: 'target_menu_humanAnkleFoot'}},
                    ]
                },
                {
                    items: [
                        {target: OETarget.humanTrunk, label: {text: 'Trunk', id: 'target_menu_humanTrunk'}},
                        {target: OETarget.humanNeckBack, label: {text: 'Neck, Back', id: 'target_menu_humanNeckBack'}},
                        {target: OETarget.humanChestWall, label: {text: 'Chest Wall', id: 'target_menu_humanChestWall'}},
                        {target: OETarget.humanAbdominalWall, label: {text: 'Abdominal Wall', id: 'target_menu_humanAbdominalWall'}},
                        {target: OETarget.humanPelvis, label: {text: 'Pelvis', id: 'target_menu_humanPelvis'}},
                        {target: OETarget.humanSpine, label: {text: 'Spine', id: 'target_menu_humanSpine'}},
                    ]
                }
            ]
        }
    ],

    [OEImplantcastTargetType.op]: [
        {
            label: {text: 'Hüfte', id: 'welcome_view_selection_implantcast_1_short'},
            subcategories: [
                {
                    label: {text: ''},
//@ADD_TARGET_IMPLANTCAST_TARGETMENU
                    items: [
                        OETargetMenuDefs.materialTestTarget,
                    ]
                },
                {
                    label: {text: 'OP-Zugang', id: 'welcome_view_selection_implantcast_1_4'},
                    items: [
                        OETargetMenuDefs.implantcastHipDorsalApproach,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_1_5'},
                    items: [
                        OETargetMenuDefs.implantcastDirectAnteriorApproach,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik Hüftschäfte', id: 'welcome_view_selection_implantcast_1_1'},
                    items: [
                        OETargetMenuDefs.implantcastActiniaStem,
                        OETargetMenuDefs.implantcastEcoFitHipStem,
                        OETargetMenuDefs.implantcastEcoFitHipStem123,
                        OETargetMenuDefs.implantcastEcoFitHipStem133123,
                        OETargetMenuDefs.implantcastEcoFitShortStem,
                        OETargetMenuDefs.implantcasticStraightStem,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik Hüftköpfe / -pfannen', id: 'welcome_view_selection_implantcast_1_2'},
                    items: [
                        OETargetMenuDefs.implantcastEcoFit2M,
                        OETargetMenuDefs.implantcastEcoFit2MSP,
                        OETargetMenuDefs.implantcastEcoFitCup,
                        OETargetMenuDefs.implantcastEcoFitCupEPORE,
                        OETargetMenuDefs.implantcastEcoFitSC,
                        OETargetMenuDefs.implantcastPEcupMuellerII,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_1_3'},
                    items: [
                        OETargetMenuDefs.implantcastDiaLocRS,
                        OETargetMenuDefs.implantcastMutarsDiaphysealImplant,
                        OETargetMenuDefs.implantcastMutarsIntramedtotalFemurMK,
                        OETargetMenuDefs.implantcastMutarsIntramedtotalFemurGenuX,
                        OETargetMenuDefs.implantcastMutarsLumic,
                        OETargetMenuDefs.implantcastMutarsProxFemur,
                        OETargetMenuDefs.implantcastMutarsProxFemurDiaphyse,
                        OETargetMenuDefs.implantcastMutarsProxFemurRS,
                        OETargetMenuDefs.implantcastMutarsProxFemurRevision,
                        OETargetMenuDefs.implantcastMUTARSPRS,
                        OETargetMenuDefs.implantcastMutarsRS,
                        OETargetMenuDefs.implantcastMutarsRScup,
                        OETargetMenuDefs.implantcastMutarsTotalesFemurMK,
                    ]
                },
            ]
        },
        {
            label: {text: 'Knie', id: 'welcome_view_selection_implantcast_2_short'},
            subcategories: [
                {
                    label: {text: 'OP-Zugang', id: 'welcome_view_selection_implantcast_2_4'},
                    items: [
                        OETargetMenuDefs.implantcastKneeLateralParapatellarApproach,
                        OETargetMenuDefs.implantcastKneeMedialParapatellarApproach,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_2_1'},
                    items: [
                        OETargetMenuDefs.implantcastACSFBAllinOne,
                        OETargetMenuDefs.implantcastACSMBAllinOne,
                        OETargetMenuDefs.humanKneeImplantcast,
                        OETargetMenuDefs.implantcastACSMB4in1,
                        OETargetMenuDefs.implantcastACSUniFB,
                        OETargetMenuDefs.implantcastACSUniSG,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_2_2'},
                    items: [
                        OETargetMenuDefs.implantcastACSSCFB,
                        OETargetMenuDefs.implantcastACSSCMB,
                        OETargetMenuDefs.implantcastEporeConeKRIundRSArthrodese,
                        OETargetMenuDefs.implantcastEporeConesCortical,
                        OETargetMenuDefs.implantcastEporeConesMetaphyseal,
                        OETargetMenuDefs.implantcastEporeMetaphysealComponentsGenuX,
                        OETargetMenuDefs.implantcastMutarsDiaphysealImplant,
                        OETargetMenuDefs.implantcastMutarsDistFemurMK,
                        OETargetMenuDefs.implantcastMutarsDistFemurRS,
                        OETargetMenuDefs.implantcastMUTARSGenuXMK,
                        OETargetMenuDefs.implantcastMutarsIntramedtotalFemurMK,
                        OETargetMenuDefs.implantcastMutarsIntramedtotalFemurGenuX,
                        OETargetMenuDefs.implantcastMUTARSKRIMK,
                        OETargetMenuDefs.implantcastMUTARSModularStem,
                        OETargetMenuDefs.implantcastMUTARSProxTibiaMK,
                        OETargetMenuDefs.implantcastMutarsTotalesFemurMK,
                        OETargetMenuDefs.implantcastMutarsTotalKneeMK,
                        OETargetMenuDefs.implantcastMutarsTotalKneeKRIMK,
                    ]
                },
                {
                    label: {text: 'Arthrodesen', id: 'welcome_view_selection_implantcast_2_3'},
                    items: [
                        OETargetMenuDefs.implantcastMutarsArthrodesisimplant,
                        OETargetMenuDefs.implantcastMutarsRSArthrodesisImplant,
                    ]
                }
            ]
        },
        {
            label: {text: 'Schulter', id: 'welcome_view_selection_implantcast_3_short'},
            subcategories: [
                {
                    label: {text: 'OP-Zugang', id: 'welcome_view_selection_implantcast_3_3'},
                    items: [OETargetMenuDefs.implantcastDeltopectoralApproach]
                },
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_3_1'},
                    items: [
                        OETargetMenuDefs.implantcastAGILONGlenoidzementfrei,
                        OETargetMenuDefs.implantcastAGILONMI,
                        OETargetMenuDefs.implantcastAGILONOmarthrosisLongFit,
                        OETargetMenuDefs.implantcastAgilonPEGlenoid,
                        OETargetMenuDefs.implantcastAGILONTraumalongfit,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_3_2'},
                    items: [
                        OETargetMenuDefs.implantcastMutarsHumerusDiaphysealImplant,
                        OETargetMenuDefs.implantcastMutarsHumerusInvers,
                        OETargetMenuDefs.implantcastMutarsProxHumerus,
                    ]
                }
            ]
        },
        {
            label: {text: 'Sprung-gelenk', id: 'welcome_view_selection_implantcast_4_short'}
        },
        {
            label: {text: 'Ellen-bogen', id: 'welcome_view_selection_implantcast_5_short'},
            subcategories: [
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_5_1'},
                    items: [
                        OETargetMenuDefs.implantcastICARA,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_5_2'},
                    items: [
                        OETargetMenuDefs.implantcastMutarsDistHumerus30mm,
                        OETargetMenuDefs.implantcastMutarsDistHumerus50mm,
                        OETargetMenuDefs.implantcastMutarsHumerusDiaphysealImplant,
                        OETargetMenuDefs.implantcastMutarsProxUlnaLongFit,
                        OETargetMenuDefs.implantcastMutarsTotalElbow,
                        OETargetMenuDefs.implantcastMutarsTotalHumerus,
                    ]
                },
            ]
        },
        {
            label: {text: 'Finger', id: 'welcome_view_selection_implantcast_6_short'},
            subcategories: [
                {
                    label: {text: ''},
                    items: [
                        OETargetMenuDefs.implantcastCarpoFit,
                        OETargetMenuDefs.implantcastHAPTic,
                    ]
                },
            ]
        },
        {
            label: {text: 'Zusatz-produkte', id: 'welcome_view_selection_implantcast_7_short'},
            subcategories: [
                {
                    label: {text: ''},
                    items: [
                        OETargetMenuDefs.implantcastIntramedullaryPlug,
                        OETargetMenuDefs.implantcastMutarsTorqueWrench,
                    ]
                },
            ]
        }
    ],

    [OEImplantcastTargetType.op + OEAlphaBetaProdTypes.beta]: [
        {
            label: {text: 'Hüfte', id: 'welcome_view_selection_implantcast_1_short'},
            subcategories: [
                {
                    label: {text: 'OP-Zugang', id: 'welcome_view_selection_implantcast_1_4'},
                    items: [
                        OETargetMenuDefs.implantcastHipDorsalApproach,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_1_5'},
                    items: [
                        OETargetMenuDefs.implantcastDirectAnteriorApproach,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik Hüftschäfte', id: 'welcome_view_selection_implantcast_1_1'},
                    items: [
                        OETargetMenuDefs.implantcastActiniaStem,
                        OETargetMenuDefs.implantcastEcoFitHipStem,
                        OETargetMenuDefs.implantcastEcoFitHipStem123,
                        OETargetMenuDefs.implantcastEcoFitHipStem133123,
                        OETargetMenuDefs.implantcastEcoFitShortStem,
                        OETargetMenuDefs.implantcasticStraightStem,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik Hüftköpfe / -pfannen', id: 'welcome_view_selection_implantcast_1_2'},
                    items: [
                        OETargetMenuDefs.implantcastEcoFit2M,
                        OETargetMenuDefs.implantcastEcoFit2MSP,
                        OETargetMenuDefs.implantcastEcoFitCup,
                        OETargetMenuDefs.implantcastEcoFitCupEPORE,
                        OETargetMenuDefs.implantcastEcoFitSC,
                        OETargetMenuDefs.implantcastPEcupMuellerII,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_1_3'},
                    items: [
                        OETargetMenuDefs.implantcastDiaLocRS,
                        OETargetMenuDefs.implantcastMutarsDiaphysealImplant,
                        OETargetMenuDefs.implantcastMutarsIntramedtotalFemurMK,
                        OETargetMenuDefs.implantcastMutarsIntramedtotalFemurGenuX,
                        OETargetMenuDefs.implantcastMutarsLumic,
                        OETargetMenuDefs.implantcastMutarsProxFemur,
                        OETargetMenuDefs.implantcastMutarsProxFemurDiaphyse,
                        OETargetMenuDefs.implantcastMutarsProxFemurRS,
                        OETargetMenuDefs.implantcastMutarsProxFemurRevision,
                        OETargetMenuDefs.implantcastMUTARSPRS,
                        OETargetMenuDefs.implantcastMutarsRS,
                        OETargetMenuDefs.implantcastMutarsRScup,
                        OETargetMenuDefs.implantcastMutarsTotalesFemurMK,
                    ]
                },
            ]
        },
        {
            label: {text: 'Knie', id: 'welcome_view_selection_implantcast_2_short'},
            subcategories: [
                {
                    label: {text: 'OP-Zugang', id: 'welcome_view_selection_implantcast_2_4'},
                    items: [
                        OETargetMenuDefs.implantcastKneeMedialParapatellarApproach
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_2_1'},
                    items: [
                        OETargetMenuDefs.implantcastACSFBAllinOne,
                        OETargetMenuDefs.implantcastACSMBAllinOne,
                        OETargetMenuDefs.humanKneeImplantcast,
                        OETargetMenuDefs.implantcastACSMB4in1,
                        OETargetMenuDefs.implantcastACSUniFB,
                        OETargetMenuDefs.implantcastACSUniSG
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_2_2'},
                    items: [
                        OETargetMenuDefs.implantcastACSSCFB,
                        OETargetMenuDefs.implantcastACSSCMB,
                        OETargetMenuDefs.implantcastEporeConeKRIundRSArthrodese,
                        OETargetMenuDefs.implantcastEporeConesCortical,
                        OETargetMenuDefs.implantcastEporeConesMetaphyseal,
                        OETargetMenuDefs.implantcastEporeMetaphysealComponentsGenuX,
                        OETargetMenuDefs.implantcastMutarsDiaphysealImplant,
                        OETargetMenuDefs.implantcastMutarsDistFemurMK,
                        OETargetMenuDefs.implantcastMutarsDistFemurRS,
                        OETargetMenuDefs.implantcastMUTARSGenuXMK,
                        OETargetMenuDefs.implantcastMutarsIntramedtotalFemurMK,
                        OETargetMenuDefs.implantcastMutarsIntramedtotalFemurGenuX,
                        OETargetMenuDefs.implantcastMUTARSKRIMK,
                        OETargetMenuDefs.implantcastMUTARSModularStem,
                        OETargetMenuDefs.implantcastMUTARSProxTibiaMK,
                        OETargetMenuDefs.implantcastMutarsTotalesFemurMK,
                        OETargetMenuDefs.implantcastMutarsTotalKneeMK,
                        OETargetMenuDefs.implantcastMutarsTotalKneeKRIMK,
                    ]
                },
                {
                    label: {text: 'Arthrodesen', id: 'welcome_view_selection_implantcast_2_3'},
                    items: [
                        OETargetMenuDefs.implantcastMutarsArthrodesisimplant,
                        OETargetMenuDefs.implantcastMutarsRSArthrodesisImplant,
                    ]
                }
            ]
        },
        {
            label: {text: 'Schulter', id: 'welcome_view_selection_implantcast_3_short'},
            subcategories: [
                {
                    label: {text: 'OP-Zugang', id: 'welcome_view_selection_implantcast_3_3'},
                    items: [OETargetMenuDefs.implantcastDeltopectoralApproach]
                },
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_3_1'},
                    items: [
                        OETargetMenuDefs.implantcastAGILONGlenoidzementfrei,
                        OETargetMenuDefs.implantcastAGILONMI,
                        OETargetMenuDefs.implantcastAGILONOmarthrosisLongFit,
                        OETargetMenuDefs.implantcastAgilonPEGlenoid,
                        OETargetMenuDefs.implantcastAGILONTraumalongfit,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_3_2'},
                    items: [
                        OETargetMenuDefs.implantcastMutarsHumerusDiaphysealImplant,
                        OETargetMenuDefs.implantcastMutarsHumerusInvers,
                        OETargetMenuDefs.implantcastMutarsProxHumerus,
                    ]
                }
            ]
        },
        {label: {text: 'Sprung-gelenk', id: 'welcome_view_selection_implantcast_4_short'}},
        {
            label: {text: 'Ellen-bogen', id: 'welcome_view_selection_implantcast_5_short'},
            subcategories: [
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_5_1'},
                    items: [
                        OETargetMenuDefs.implantcastICARA,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_5_2'},
                    items:
                    [
                        OETargetMenuDefs.implantcastMutarsDistHumerus30mm,
                        OETargetMenuDefs.implantcastMutarsDistHumerus50mm,
                        OETargetMenuDefs.implantcastMutarsHumerusDiaphysealImplant,
                        OETargetMenuDefs.implantcastMutarsProxUlnaLongFit,
                        OETargetMenuDefs.implantcastMutarsTotalElbow,
                    ]
                },
            ]
        },
        {
            label: {text: 'Finger', id: 'welcome_view_selection_implantcast_6_short'},
            subcategories: [
                {
                    label: {text: ''},
                    items:
                    [
                        OETargetMenuDefs.implantcastCarpoFit,
                        OETargetMenuDefs.implantcastHAPTic
                    ]
                },
            ]
        },
        {
            label: {text: 'Zusatz-produkte', id: 'welcome_view_selection_implantcast_7_short'},
            subcategories: [
                {
                    label: {text: ''},
                    items: [
                        OETargetMenuDefs.implantcastIntramedullaryPlug,
                        OETargetMenuDefs.implantcastMutarsTorqueWrench,
                    ]
                },
            ]
        }
    ],

    [OEImplantcastTargetType.op + OEAlphaBetaProdTypes.prod]: [
        {
            label: {text: 'Hüfte', id: 'welcome_view_selection_implantcast_1_short'},
            subcategories: [
                {
                    label: {text: 'OP-Zugang', id: 'welcome_view_selection_implantcast_1_4'},
                    items: [
                        OETargetMenuDefs.implantcastHipDorsalApproach,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_1_5'},
                    items: [
                        OETargetMenuDefs.implantcastDirectAnteriorApproach,
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik Hüftschäfte', id: 'welcome_view_selection_implantcast_1_1'},
                    items: [
                        OETargetMenuDefs.implantcastActiniaStem,
                        OETargetMenuDefs.implantcastEcoFitHipStem,
                        OETargetMenuDefs.implantcastEcoFitHipStem123,
                        OETargetMenuDefs.implantcastEcoFitHipStem133123,
                        OETargetMenuDefs.implantcastEcoFitShortStem
                    ]
                },
                {
                    label: {text: 'Primärendoprothetik Hüftköpfe / -pfannen', id: 'welcome_view_selection_implantcast_1_2'},
                    items: [
                        OETargetMenuDefs.implantcastEcoFit2M,
                        OETargetMenuDefs.implantcastEcoFit2MSP,
                        OETargetMenuDefs.implantcastEcoFitCup,
                        OETargetMenuDefs.implantcastEcoFitCupEPORE,
                        OETargetMenuDefs.implantcastEcoFitSC,
                        OETargetMenuDefs.implantcastPEcupMuellerII,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_1_3'},
                    items: [
                        OETargetMenuDefs.implantcastDiaLocRS,
                        OETargetMenuDefs.implantcastMutarsProxFemur,
                        OETargetMenuDefs.implantcastMutarsRS,
                        OETargetMenuDefs.implantcastMutarsRScup,
                    ]
                },
            ]
        },
        {
            label: {text: 'Knie', id: 'welcome_view_selection_implantcast_2_short'},
            subcategories: [
                // {
                //     label: {text: 'welcome_view_selection_implantcast_2_4'},
                //     items: [
                //         OETargetMenuDefs.implantcastKneeMedialParapatellarApproach
                //     ]
                // },
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_2_1'},
                    items: [
                        OETargetMenuDefs.implantcastACSFBAllinOne,
                        OETargetMenuDefs.implantcastACSMBAllinOne,
                        OETargetMenuDefs.humanKneeImplantcast,
                        OETargetMenuDefs.implantcastACSMB4in1,
                        OETargetMenuDefs.implantcastACSUniFB,
                        OETargetMenuDefs.implantcastACSUniSG,
                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_2_2'},
                    items: [
                        OETargetMenuDefs.implantcastACSSCFB,
                        OETargetMenuDefs.implantcastACSSCMB,
                        OETargetMenuDefs.implantcastEporeConeKRIundRSArthrodese,
                        OETargetMenuDefs.implantcastEporeConesCortical,
                        OETargetMenuDefs.implantcastEporeConesMetaphyseal,
                        OETargetMenuDefs.implantcastEporeMetaphysealComponentsGenuX,
                        OETargetMenuDefs.implantcastMutarsDistFemurMK,
                        OETargetMenuDefs.implantcastMUTARSGenuXMK,
                        OETargetMenuDefs.implantcastMUTARSKRIMK,
                        OETargetMenuDefs.implantcastMUTARSModularStem,
                    ]
                },
                {
                    label: {text: 'Arthrodesen', id: 'welcome_view_selection_implantcast_2_3'},
                    items: [
                        OETargetMenuDefs.implantcastMutarsArthrodesisimplant
                    ]
                }
            ]
        },
        {
            label: {text: 'Schulter', id: 'welcome_view_selection_implantcast_3_short'},
            subcategories: [
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_3_1'},
                    items: [
                        OETargetMenuDefs.implantcastAGILONGlenoidzementfrei,
                        OETargetMenuDefs.implantcastAGILONMI,
                        OETargetMenuDefs.implantcastAGILONOmarthrosisLongFit,
                        OETargetMenuDefs.implantcastAgilonPEGlenoid,
                        OETargetMenuDefs.implantcastAGILONTraumalongfit,

                    ]
                },
                {
                    label: {text: 'Revisions- und Tumorendoprothetik', id: 'welcome_view_selection_implantcast_3_2'},
                    items: [
                        OETargetMenuDefs.implantcastMutarsHumerusDiaphysealImplant
                    ]
                }
            ]
        },
        {
            label: {text: 'Ellen-bogen', id: 'welcome_view_selection_implantcast_5_short'},
            subcategories: [
                {
                    label: {text: 'Primärendoprothetik', id: 'welcome_view_selection_implantcast_5_1'},
                    items: [
                        OETargetMenuDefs.implantcastICARA,
                    ]
                }
            ]
        },
        {
            label: {text: 'Finger', id: 'welcome_view_selection_implantcast_6_short'},
            subcategories: [
                {
                    label: {text: ''},
                    items: [
                        OETargetMenuDefs.implantcastCarpoFit,
                        OETargetMenuDefs.implantcastHAPTic,
                    ]
                },
            ]
        },
        // {
        //     label: {text: 'Zusatz-produkte', id: 'welcome_view_selection_implantcast_7_short'},
        //     subcategories: [
        //         {
        //             label: {text: ''},
        //             items: [
        //                 OETargetMenuDefs.implantcastIntramedullaryPlug,
        //                 OETargetMenuDefs.implantcastMutarsTorqueWrench,
        //             ]
        //         },
        //     ]
        // }
    ]
};

OEImplantcastStartSelectionContent.modules = [
    {id: OEImplantcastTargetType.op, icon: OEIconCodes.implantcast.opTarget, categories: OEImplantcastStartSelectionContent[OEImplantcastTargetType.op]},
    {id: OEImplantcastTargetType.anatomy, icon: OEIconCodes.implantcast.anatomyTarget, categories: OEImplantcastStartSelectionContent[OEImplantcastTargetType.anatomy]}
];

OEImplantcastStartSelectionContent.modulesBeta = [
    {id: OEImplantcastTargetType.op, icon: OEIconCodes.implantcast.opTarget, categories: OEImplantcastStartSelectionContent[OEImplantcastTargetType.op + OEAlphaBetaProdTypes.beta]},
    {id: OEImplantcastTargetType.anatomy, icon: OEIconCodes.implantcast.anatomyTarget, categories: OEImplantcastStartSelectionContent[OEImplantcastTargetType.anatomy]}
];

OEImplantcastStartSelectionContent.modulesProduction = [
    {id: OEImplantcastTargetType.op, icon: OEIconCodes.implantcast.opTarget, categories: OEImplantcastStartSelectionContent[OEImplantcastTargetType.op + OEAlphaBetaProdTypes.prod]},
    {id: OEImplantcastTargetType.anatomy, icon: OEIconCodes.implantcast.anatomyTarget, categories: OEImplantcastStartSelectionContent[OEImplantcastTargetType.anatomy]}
];